import { useEffect, useMemo, useState } from 'react';

export const useResizeListener = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const isMobile = useMemo(() => width <= 768, [width]);
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      const bodyWidth = entries[0].contentRect.width;
      //  Only update if width actually changed
      setWidth((prev) => (prev !== bodyWidth ? bodyWidth : prev));
    });
    resizeObserver.observe(document.body);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { innerWidth: width, isMobile };
};
